import { IUser } from "../../../context/types";
import { getUserAuthLocalStorage } from "../../../context/utils";
import { getDecryptedCredentials, hasStoredCredentials } from "../../../utils/cryptoUtils";
import { IChangePasswordActionData, IExpiredPasswordActionData, IForgotPasswordParams, IForgotPasswordRequest, IForgotPasswordRequestState } from "../../../utils/types";

export function changeLanguage(lang: string | null, i18n, setErrorLogin) {
  let langChangeTo = lang?.toUpperCase();
  switch (langChangeTo) {
    case "es".toUpperCase():
    case "es-es".toUpperCase():
      i18n.changeLanguage("es-ES").catch((err) => {
        if (setErrorLogin) setErrorLogin(err.toString());
      });
      break;
    case "en".toUpperCase():
    case "en-US".toUpperCase():
      i18n.changeLanguage("en-US").catch((err) => {
        if (setErrorLogin) setErrorLogin(err.toString());
      });
      break;
    case "pt".toUpperCase():
    case "pt-BR".toUpperCase():
      i18n.changeLanguage("pt-BR").catch((err) => {
        if (setErrorLogin) setErrorLogin(err.toString());
      });
      break;
  }
}
export function getUrlTerm(user, countries, urlConf, handleChange): string {
  let urlTerm: string | undefined;
  if (user?.countryId) {
    let country = countries.find(
      (country) => country.CountryID === user.countryId
    );
    if (country) {
      urlTerm = country.CountryParameters.find(
        (param) => param.Dsc === "URL_TERMO"
      )?.Val;
    }
  }
  urlConf.tos = urlTerm;
  if (urlTerm) return urlTerm;

  if (countries?.length === 0) return "";

  let country = countries[0];
  let language_country = country.CountryParameters.find(
    (param) => param.Dsc === "CULTURE_DEFAULT"
  )?.Val;

  let URL_TERMO_country = country.CountryParameters.find(
    (param) => param.Dsc === "URL_TERMO"
  )?.Val;

  handleChange("language", language_country ?? "pt-BR");
  urlConf.tos = country.CountryParameters.find(
    (param) => param.Dsc === "URL_TERMO"
  )?.Val;
  return URL_TERMO_country ?? "";
}

export function handleChangeAux(
  field: string,
  value: any,
  getlangStorage,
  setUser,
  i18n,
  setErrorLogin
) {
  setUser((prev) => ({ ...prev, [field]: value }));
  changeLanguage(
    getlangStorage() === null ? "" : getlangStorage(),
    i18n,
    setErrorLogin
  );
}

export function fillUserTerms(userAuthStorage: IUser, setUser) {
  if (
    userAuthStorage?.tosAgree !== null &&
    userAuthStorage?.tosAgree !== undefined &&
    userAuthStorage?.tosAgree && 
    userAuthStorage?.rememberLogin === true
  ) {
    setUser((prev) => ({ ...prev, terms: true }));
  }
}

export function fillUserKeepConnected(userAuthStorage: IUser, setUser) {
  if (
    userAuthStorage?.rememberLogin !== null &&
    userAuthStorage?.rememberLogin !== undefined &&
    userAuthStorage?.rememberLogin
  ) {
    setUser((prev) => ({ ...prev, keepConnected: true }));
  }
}

export function fillUserUsername(userAuthStorage: IUser, setUser) {
  if (
    userAuthStorage?.username !== null &&
    userAuthStorage?.username !== undefined &&
    userAuthStorage?.username !== ""
  ) {
    setUser((prev) => ({
      ...prev,
      username: userAuthStorage?.username ?? "",
    }));
  }
}

export function fillPassword(userAuthStorage: IUser, setUser) {
  if (
    userAuthStorage?.password !== null &&
    userAuthStorage?.password !== undefined &&
    userAuthStorage?.password !== ""
  ) {
    setUser((prev) => ({
      ...prev,
      password: userAuthStorage?.password ?? "",
    }));
  }
}

export function fillUserUsernameFromEncrypted(setUser) {
  if (hasStoredCredentials()) {
    const encryptedCredentials = getDecryptedCredentials();
    if (encryptedCredentials?.username) {
      setUser((prev) => ({
        ...prev,
        username: prev.username || encryptedCredentials.username, 
      }));
    }
  }
}

export function fillPasswordFromEncrypted(setUser) {
  if (hasStoredCredentials()) {
    const encryptedCredentials = getDecryptedCredentials();
    if (encryptedCredentials?.password) {
      setUser((prev) => ({
        ...prev,
        password: prev.password || encryptedCredentials.password, 
      }));
    }
  }
}

export function fillUserTermsFromEncrypted(setUser) {
  if (hasStoredCredentials()) {
    const encryptedCredentials = getDecryptedCredentials();
    if (encryptedCredentials?.tosAgree && encryptedCredentials?.rememberLogin) {
      setUser((prev) => ({ 
        ...prev, 
        terms: prev.terms || true 
      }));
    }
  }
}

export function fillUserKeepConnectedFromEncrypted(setUser) {
  if (hasStoredCredentials()) {
    const encryptedCredentials = getDecryptedCredentials();
    if (encryptedCredentials?.rememberLogin) {
      setUser((prev) => ({ 
        ...prev, 
        keepConnected: prev.keepConnected || true 
      }));
    }
  }
}

export function loadDefinitionsAuthStorage(setUser) {
  let userAuthStorage = getUserAuthLocalStorage();
  
  if (userAuthStorage !== null && userAuthStorage !== undefined) {
    fillUserTerms(userAuthStorage, setUser);
    fillUserKeepConnected(userAuthStorage, setUser);
    fillUserUsername(userAuthStorage, setUser);
    fillPassword(userAuthStorage, setUser);
  }
  

  fillUserTermsFromEncrypted(setUser);
  fillUserKeepConnectedFromEncrypted(setUser);
  fillUserUsernameFromEncrypted(setUser);
  fillPasswordFromEncrypted(setUser);
}


export function migrateToEncryptedCredentials(userAuthStorage: IUser, user: any) {

  if (userAuthStorage?.username && userAuthStorage?.password && userAuthStorage?.rememberLogin) {
 
    const { saveEncryptedCredentials } = require('../../../utils/cryptoUtils');
    
    const credentials = {
      username: userAuthStorage.username,
      password: userAuthStorage.password,
      countryId: user?.countryId || 1, 
      language: user?.language || 'pt-BR',
      rememberLogin: userAuthStorage.rememberLogin,
      tosAgree: userAuthStorage.tosAgree || false,
    };
    
   
    saveEncryptedCredentials(credentials);
    
    console.log('Credenciais migradas para o sistema criptografado');
  }
}

export function handleForgotPassword(paramFP: IForgotPasswordRequest) {
  const searchParams = new URLSearchParams(paramFP.location.search);
  const path = searchParams.get(paramFP.searchParam);
  if (paramFP?.paramsGet?.length > 0) {
    paramFP.paramsGet.forEach((param) => {
      param.value = searchParams.get(param.key);
    });
  }
  if (path === paramFP.pathToCheck) {
    const stateRedirect: IForgotPasswordRequestState = {
      urlParamForgotPassword: paramFP.paramsGet,
      actionPath: paramFP.pathToCheck,
    };
    paramFP.navigate(paramFP.pathToRedirect, {
      state: { stateRedirect: stateRedirect },
    });
  }
}

export function getObjectFromIForgotPasswordParams(
  forgotPasswordParamsArray: IForgotPasswordParams[] | undefined,
  keyFind: string
) {
  const findObject: IForgotPasswordParams | undefined =
    forgotPasswordParamsArray?.find((item) => item.key === keyFind);
  return findObject;
}

export function getDataPostChangePasswordActionToPassEndPoint(
  changePasswordActionData: IChangePasswordActionData
) {
  const dataResult = {
    UserAutoScroll: true,
    Data: "2022-11-05T00:00:00",
    HorarioIni: "2022-12-05T21:00:00",
    Horario: "2022-12-05T21:00:00",
    Language: {
      Id: 1,
    },
    Periodicidade: {
      Id: 1,
    },
    Praca: {
      Id: 69,
      Desc: "RT PAYTV",
      Abrev: "RTP",
    },
    Target: {
      Id: 1,
    },
    Indice: 0,
    Ordenacao: 0,
    Country: {
      CountryID: 1,
    },
    PracaImagem: {},
    ChangeAutoUpdate: false,
    TipoBase: 0,
    Password: changePasswordActionData.oldPassword,
    NewPassword: changePasswordActionData.newPassword,
    ConfirmationPassword: changePasswordActionData.newConfirmPassword,
  };
  return dataResult;
}
export function getDataPostChangePasswordActionToEsqueceuSenhaEndPoint(
  changePasswordActionData: IChangePasswordActionData
) {
  const dataRequestForm = {
    countryId: changePasswordActionData.countryId,
    guid: changePasswordActionData.token,
    language: changePasswordActionData.language,
    newPassword: changePasswordActionData.newPassword,
    confirmationPassword: changePasswordActionData.newConfirmPassword,
  };
  return dataRequestForm;
}

export function getDataPostChangePasswordActionToExpiredSenhaEndPoint(
  expiredPasswordActionData: IExpiredPasswordActionData
) {
  const dataRequestForm = {
    UserName: expiredPasswordActionData.UserName,
    CountryId: expiredPasswordActionData.CountryId,
    Password: expiredPasswordActionData.Password,
    NewPassword: expiredPasswordActionData.NewPassword,
    ConfirmationPassword: expiredPasswordActionData.ConfirmationPassword,
  };
  return dataRequestForm;
}
